// Remove all non-digit character
export const keepOnlyDigits = (value: string) => {
	return value?.replace(/\D/g, "")
}

export const secondPhoneContainsFirst = (phone1: string, phone2: string) => {
	const rawPhone1 = keepOnlyDigits(phone1)
	const rawPhone2 = keepOnlyDigits(phone2)

	return rawPhone2?.includes(rawPhone1)
}

const MIN_PHONE_NUMBER_LENGTH = 8

export const isProbablyAPhoneNumber = (value?: string): boolean => {
	if (!value) {
		return false
	}

	const onlyDigits = keepOnlyDigits(value)
	const isAllDigits = value.length === onlyDigits.length

	return isAllDigits && onlyDigits.length >= MIN_PHONE_NUMBER_LENGTH
}

const MIN_DIGITS_TO_MATCH_BY_SUFFIX = 10

export const isSamePhone = (firstPhone?: string, secondPhone?: string): boolean => {
	const first = keepOnlyDigits(firstPhone || "")
	const second = keepOnlyDigits(secondPhone || "")

	if (!first || !second) {
		return false
	}

	if (first === second) {
		return true
	}

	const [shorter, longer] = first.length < second.length ? [first, second] : [second, first]

	return shorter.length >= MIN_DIGITS_TO_MATCH_BY_SUFFIX && longer.endsWith(shorter)
}
